var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',_vm._g(_vm._b({attrs:{"title":"Page Object Permissions","title-tag":"h2","ok-only":""}},'b-modal',_vm.$attrs,false),_vm.$listeners),[_c(_setup.ObjectPermissions,{attrs:{"markdown-content":_vm.markdownContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }